import React, { Component } from "react";
import moment from "moment";
import "./style.scss";
import {
  updateForm,
  getCommonApi,
  commonCreateApi,
} from "redux/actions/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { NormalButton, TableWrapper } from "component/common";
import closeIcon from "assets/images/close.png";
import { Toast } from "service/toast";
export class CustomerOutletStatusClass extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      customerRequestList: {},
      headerDetails: [
        { label: "S. No" },
        { label: "Log Date" },
        {
          label: "Code",
        },
        {
          label: "From Site",
        },
        { label: "Request Site" },
        { label: "Status" },

        { label: "Actions", className: "d-flex justify-content-center" },

        //{ label: "" },
      ],
    };
  }

  // outletrequestcustomer initial call
  componentDidMount = () => {
    this.outletrequestcustomerList();
  };

  // outletrequestcustomer
  outletrequestcustomerList = () => {
    let dateFormat = moment().format("YYYY-MM-DD");
    this.props
      .getCommonApi(
        `outletrequestcustomer/waitingloglist/?given_date=${dateFormat}`
      )
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({ customerRequestList: data });
        }
      });
  };

  //

  // handleClickRequest
  handleApprovedRejected = (id, status) => {
    let body = {
      log_id: id,
      req_status: status,
    };
    this.props
      .commonCreateApi(`outletrequestcustomer/waitingapproval/`, body)
      .then((res) => {
        let { status, message } = res;
        if (status === 200) {
          Toast({
            type: "success",
            message: "Status Updated Successfully",
          });
          this.outletrequestcustomerList();
        }
      });
  };

  render() {
    let { customerRequestList, headerDetails } = this.state;
    let { t } = this.props;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-10 col-md-12 co-12 offset-xl-1">
              <h6 className="pt-4">Customer Outlet Requests</h6>
              <div className="billing-table">
                <div className="py-4">
                  <div className="table-container">
                    <TableWrapper
                      headerDetails={headerDetails}
                      queryHandler={this.handlePagination}
                      // pageMeta={pageMeta}
                    >
                      {customerRequestList &&
                      Array.isArray(customerRequestList) &&
                      customerRequestList ? (
                        customerRequestList?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div className="text-left">
                                  {/* {item.cust_code}*/}
                                  {index + 1}
                                </div>
                              </td>
                              <td>
                                <div className="text-left">{item.log_date}</div>
                              </td>

                              <td>
                                <div className="text-left">
                                  {item.cust_code}
                                </div>
                              </td>
                              <td>
                                <div className="text-left">
                                  {item.from_site}
                                </div>
                              </td>
                              <td>
                                <div className="text-left ">
                                  {item.requesting_site}
                                </div>
                              </td>
                              <td>
                                <div className="text-left ">
                                  {item.req_status}
                                </div>
                              </td>

                              <td className="position-relative">
                                <div className="d-flex justify-content-center">
                                  <NormalButton
                                    buttonClass={"mr-2"}
                                    mainbgrev={true}
                                    className="confirm fs-11"
                                    label={t("Approve")}
                                    outline={false}
                                    onClick={() =>
                                      this.handleApprovedRejected(
                                        item.id,
                                        "Approved"
                                      )
                                    }
                                    disabled={item.req_status !== "Waiting"}
                                  />
                                  <NormalButton
                                    buttonClass={"mx-0"}
                                    mainbgrev={true}
                                    className="confirm fs-11"
                                    label={t("Reject")}
                                    outline={false}
                                    onClick={() => {
                                      this.handleApprovedRejected(
                                        item.id,
                                        "Rejected"
                                      );
                                    }}
                                    disabled={item.req_status !== "Waiting"}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <td colSpan={12} className="text-center">
                          No requests found
                        </td>
                      )}
                    </TableWrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  basicApptDetail: state.appointment.basicApptDetail,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
    },
    dispatch
  );
};

export const CustomerOutletStatus = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(CustomerOutletStatusClass)
);
